export const DenyOptions = [
  { key: '1', text: 'Not Permitted', value: 'Not Permitted' },
  {
    key: '2',
    text: 'NOC is not received from Copyright Holder',
    value: 'NOC is not received from Copyright Holder',
  },
  {
    key: '3',
    text: 'Against Institution Policy',
    value: 'Against Institution Policy',
  },
  { key: '4', text: 'Insufficient Fund', value: 'Insufficient Fund' },
];
export const ApproveOptions = [
  { key: '1', text: 'Verified', value: 'Verified' },
  { key: '2', text: 'Request Completed', value: 'Request Completed' },
  { key: '3', text: 'Authorized', value: 'Authorized' },
];
export const VerifyOptions = [
  { key: '1', text: 'Verified', value: 'Verified' },
];
export const ApproveOptions1 = [
  { key: '1', text: 'Authorized', value: 'Authorized' },
];
export const moveOptions = [
  { key: '1', text: 'Request Completed', value: 'Request Completed' },
];

export const checkboxSettingsOptions = [
  { key: '1', text: 'Clone Item', value: 'clone item' },
];

export const settingsOptions = [
  { key: '1', text: 'TextBox', value: 'TextBox' },
  { key: '2', text: 'TextArea', value: 'TextArea' },
  { key: '3', text: 'DropDown', value: 'DropDown' },
  { key: '4', text: 'Add Files', value: 'AddFiles' },
  { key: '5', text: 'Add Photograph', value: 'AddPhotograph' },
  // { key: '6', text: 'Barcode', value: 'Barcode' },
  { key: '7', text: 'Date Picker', value: 'DatePicker' },
  { key: '8', text: 'Parent', value: 'Parent' },
  // { key: '9', text: 'Masters', value: 'Masters' },
  { key: '10', text: 'Users', value: 'Users' },
  { key: '11', text: 'Dynamic MetaData', value: 'Dynamicmetadata' },
  {
    key: '12',
    text: 'Parent Dynamic MetaData',
    value: 'ParentDynamicmetadata',
  },
  { key: '13', text: 'Dynamic Table', value: 'DynamicTable' },
  //do not use index 14, already taken
  { key: '15', text: 'Date & Time', value: 'DateTime' },
  { key: '16', text: 'Checkbox', value: 'Checkbox' },
  { key: '17', text: 'Scan Area', value: 'ScanArea' },
  { key: '18', text: 'Current User', value: 'CurrentUser' },
  // { key: '14', text: 'Checkbox', value: 'checkbox' },
  // { key: '15', text: 'Tab', value: 'tab' },
  // { key: '16', text: 'Dropdown & Tab', value: 'dropdownWithTab' },
];

export const metaDataOptions = [
  { key: '1', text: 'TextBox', value: 'TextBox' },
  { key: '2', text: 'TextArea', value: 'TextArea' },
  { key: '3', text: 'Dropdown', value: 'DropDown' },
  { key: '4', text: 'Add Files', value: 'AddFiles' },
  { key: '5', text: 'Add Photograph', value: 'AddPhotograph' },
  // { key: '6', text: 'Barcode', value: 'Barcode' },
  { key: '7', text: 'Date Picker', value: 'DatePicker' },
  { key: '8', text: 'Parent', value: 'Parent' },
  { key: '9', text: 'Masters', value: 'Masters' },
  { key: '10', text: 'Users', value: 'Users' },
  { key: '11', text: 'Link', value: 'link' },
  { key: '12', text: 'Current User', value: 'CurrentUser' },
  { key: '13', text: 'Date & Time', value: 'DateTime' },
  //do not use index 14, already taken
  { key: '15', text: 'Dynamic Table', value: 'DynamicTable' },
  { key: '16', text: 'Checkbox', value: 'Checkbox' },
  { key: '17', text: 'Scan Area', value: 'ScanArea' },
  { key: '18', text: 'MetaData From Parent', value: 'metadataFromParent' },
];

export const validationOptions = [
  { key: '1', text: 'None', value: 'None' },
  { key: '2', text: 'Alpha', value: 'Alpha' },
  { key: '3', text: 'Numeric', value: 'Numeric' },
  { key: '4', text: 'Alpha Numeric', value: 'Alpha Numeric' },
  { key: '5', text: 'Email', value: 'Email' },
  { key: '6', text: 'Alpha & Mandatory', value: 'AlphaMandatory' },
  { key: '7', text: 'Numeric & Mandatory', value: 'NumericMandatory' },
  {
    key: '8',
    text: 'Alpha Numeric & Mandatory',
    value: 'AlphaNumericMandatory',
  },
];

export const settingsdummyOptions = [
  { key: '1', text: 'Option 1', value: 'Option 1' },
  { key: '2', text: 'Option 2', value: 'Option 2' },
  { key: '3', text: 'Option 3', value: 'Option 3' },
];

export const barcodeOptions = [
  {
    key: '1',
    text: 'Code-128',
    value: 'Code128',
    text2: 'encodes the full ASCII set [0...127]',
  },
  {
    key: '2',
    text: 'Code-11',
    value: 'Code11',
    text2: ' encodes numeric data [0...9]and[-]',
  },
  {
    key: '3',
    text: 'Code-2of5 Interleaved',
    value: 'Code25IL',
    text2: 'encodes numeric data(alias ITF)',
  },
  {
    key: '4',
    text: 'Code-39',
    value: 'Code39',
    text2: 'encodes [0..9 A..Z -.$/+% Space]',
  },
  {
    key: '5',
    text: 'Code-39 Full ASCII',
    value: 'Code39FullASCII',
    text2: 'encodes the full ASCII set [0..127]',
  },
  {
    key: '6',
    text: 'Code-93',
    value: 'Code93',
    text2: 'encodes [0..9 A..Z -.$/+% Space]',
  },
  {
    key: '7',
    text: 'Flattermarken',
    value: 'Flattermarken',
    text2: 'encodes numeric data [0..9]',
  },
  {
    key: '8',
    text: 'GS1-128 (UCC/EAN-128)',
    value: 'EANUCC128',
    text2: 'enter digits and AIs (FNC1 = /F)',
  },
  {
    key: '9',
    text: 'MSI',
    value: 'MSI',
    text2: 'encodes numeric data [0..9]',
  },
  {
    key: '10',
    text: 'Pharmacode One-Track',
    value: 'OneTrackPharmacode',
    text2: 'encodes numeric [0..9] and generic data',
  },
  {
    key: '11',
    text: 'Pharmacode Two-Track',
    value: 'TwoTrackPharmacode',
    text2: 'Encodes numeric [0..9] and generic data',
  },
  {
    key: '12',
    text: 'Telepen Alpha',
    value: 'TelepenAlpha',
    text2: 'Encodes the full ASCII set [0..127]',
  },
];
